import { http } from '@/http/axios.js'
// 重新执行 V2 机审。
export function rerunReviewOrderAPI(orderNo) {
  return http({
    url: "/admin/review/v2/order/rerun",
    method: "post",
    data: { orderNo },
  });
}

// 审核列表
export function getReviewListAPI(params) {
  return http({
    url: '/admin/review/order/page',
    method: 'get',
    params
  })
}
// 领单
export function getReviewOrderDrawAPI(orderNo) {
  return http({
    url: '/admin/review/order/draw',
    method: 'post',
    data: { orderNo }
  })
}
// 领单
export function handleReviewOrderAbandonAPI(orderNo) {
  return http({
    url: '/admin/review/order/abandon',
    method: 'post',
    data: { orderNo }
  })
}
// 审核订单详情
export function getReviewOrderDetailAPI(orderNo) {
  return http({
    url: '/admin/review/order/detail',
    method: 'get',
    params: { orderNo }
  })
}
// 统计
export function getReviewOrderStaticAPI() {
  return http({
    url: '/admin/review/order/status/stat',
    method: 'get'
  })
}
export function getOrderRiskReviewDetailAPI(orderNo) {
  return http({
    url: '/admin/order/review/detail',
    method: 'get',
    params: { orderNo }
  })
}
